export default "__VITE_ASSET__DuWJ1Apg__";